import { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { PanelsTopLeft } from "lucide-react";

const previewSrc = `${process.env.PUBLIC_URL || ""}/images/home-gymplanner.png`;

export default function ProductPreview() {
  const [imageStatus, setImageStatus] = useState("loading");

  return (
    <Box component="figure" sx={{ m: 0 }}>
      <Box
        sx={(theme) => ({
          overflow: "hidden",
          borderRadius: 3,
          border: "1px solid",
          borderColor: "grey.300",
          bgcolor: "background.paper",
          boxShadow: `0 24px 64px ${alpha(theme.palette.black.main, 0.2)}`,
        })}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{
            px: { xs: 2, md: 3 },
            py: 1.5,
            bgcolor: "light.main",
            borderBottom: "1px solid",
            borderColor: "grey.300",
          }}
        >
          <Stack direction="row" spacing={0.75} aria-hidden="true">
            {[0, 1, 2].map((dot) => (
              <Box
                key={dot}
                sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: "grey.300" }}
              />
            ))}
          </Stack>
          <Typography sx={{ color: "text.secondary", fontSize: "0.6875rem", fontWeight: 500 }}>
            Gymplanner / Planificador
          </Typography>
        </Stack>
        <Box
          sx={{
            position: "relative",
            aspectRatio: "3817 / 1907",
            minHeight: imageStatus === "error" ? 300 : 0,
            bgcolor: "light.main",
          }}
        >
          {imageStatus !== "error" && (
            <Box
              component="img"
              src={previewSrc}
              width={3817}
              height={1907}
              alt="Planner de Gymplanner con el catálogo de ejercicios y el programa semanal."
              onLoad={() => setImageStatus("loaded")}
              onError={() => setImageStatus("error")}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: imageStatus === "loaded" ? "block" : "none",
              }}
            />
          )}
          {imageStatus === "error" && (
            <Stack
              alignItems="center"
              justifyContent="center"
              spacing={2}
              sx={{ position: "absolute", inset: 0, p: 3, textAlign: "center" }}
            >
              <Box sx={{ color: "grey.500", mb: 1 }}>
                <PanelsTopLeft size={48} strokeWidth={1} aria-hidden="true" />
              </Box>
              <Typography
                sx={{
                  color: "text.primary",
                  fontWeight: 600,
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                }}
              >
                Tu espacio de planificación.
              </Typography>
              <Typography sx={{ color: "text.secondary", maxWidth: 320 }}>
                No se ha podido cargar la captura del planner. Puedes explorar el producto desde
                «Abrir planificador».
              </Typography>
            </Stack>
          )}
        </Box>
      </Box>
      <Typography
        component="figcaption"
        sx={{ mt: 2, textAlign: "center", color: "grey.400", fontSize: "0.75rem" }}
      >
        {imageStatus === "error"
          ? "Vista previa del producto no disponible"
          : "El planner de Gymplanner · Vista de escritorio"}
      </Typography>
    </Box>
  );
}
